<template>
  <div>
    <div class="help-buttons">
      <h2>
        {{ $tv('categoryTitle', 'guide') }}
      </h2>
    </div>
    <div class="pure-g cards">
      <div
        class="pure-u-1 pure-u-md-1-3"
        v-for="category in guideCategoryList"
        :key="category.id"
      >
        <NuxtLink
          :to="localePath('/guides' + '/' + category.Url)"
          class="link--with-icon"
        >
          <ImageCard
            class="category__card"
            :image="category.Image"
            :title="category.Title"
            :description="category.ShortDescription"
          />
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script>
import ImageCard from '../ImageCard'

export default {
  name: 'GuideCategoryListView',
  components: {ImageCard},
  props: {
    guideCategoryList: {
      type: Array || null,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
.category__card {
  min-height: 13.4rem;
  flex-grow: 1;
}
</style>
